var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuQuick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8192_32",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8192_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 20C6.16667 20 5.45833 19.7083 4.875 19.125C4.29167 18.5417 4 17.8333 4 17H1.5L1.95 15H4.775C5.05833 14.6833 5.39167 14.4375 5.775 14.2625C6.15833 14.0875 6.56667 14 7 14C7.43333 14 7.84167 14.0875 8.225 14.2625C8.60833 14.4375 8.94167 14.6833 9.225 15H13.4L15.5 6H4.55L4.65 5.575C4.75 5.10833 4.97917 4.72917 5.3375 4.4375C5.69583 4.14583 6.11667 4 6.6 4H18L17.075 8H20L23 12L22 17H20C20 17.8333 19.7083 18.5417 19.125 19.125C18.5417 19.7083 17.8333 20 17 20C16.1667 20 15.4583 19.7083 14.875 19.125C14.2917 18.5417 14 17.8333 14 17H10C10 17.8333 9.70833 18.5417 9.125 19.125C8.54167 19.7083 7.83333 20 7 20ZM15.925 13H20.75L20.85 12.475L19 10H16.625L15.925 13ZM15.45 6.175L15.5 6L13.4 15L13.45 14.825L14.3 11.175L15.45 6.175ZM0.5 13.325L1 11.325H6.5L6 13.325H0.5ZM2.5 9.675L3 7.675H9.5L9 9.675H2.5ZM7 18C7.28333 18 7.52083 17.9042 7.7125 17.7125C7.90417 17.5208 8 17.2833 8 17C8 16.7167 7.90417 16.4792 7.7125 16.2875C7.52083 16.0958 7.28333 16 7 16C6.71667 16 6.47917 16.0958 6.2875 16.2875C6.09583 16.4792 6 16.7167 6 17C6 17.2833 6.09583 17.5208 6.2875 17.7125C6.47917 17.9042 6.71667 18 7 18ZM17 18C17.2833 18 17.5208 17.9042 17.7125 17.7125C17.9042 17.5208 18 17.2833 18 17C18 16.7167 17.9042 16.4792 17.7125 16.2875C17.5208 16.0958 17.2833 16 17 16C16.7167 16 16.4792 16.0958 16.2875 16.2875C16.0958 16.4792 16 16.7167 16 17C16 17.2833 16.0958 17.5208 16.2875 17.7125C16.4792 17.9042 16.7167 18 17 18Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuQuick);
export default __webpack_public_path__ + "static/media/menu_quick.f3dc7a85b1fdda38a0c857a4804f6521.svg";
export { ForwardRef as ReactComponent };